export default class DesignTeamShifter {
  constructor() {
    N2.handle('click', "[data-action='shift-team']", function(e) {
      var $this = $(this);
      var $shiftForm = $(".shift-team-form[data-target=" + $this.data("target") + "]")
      $shiftForm.toggleClass('hidden');
      if ($shiftForm.hasClass('hidden')) {
        $this.html('Shift')
      } else {
        $this.html('Cancel')
      }
    });
  }
}
